import React from 'react';
import useAuth from '../../shared/hooks/useAuth';
import { Navigate, Outlet } from 'react-router-dom';

export const RequireCompany = () => {
  const { activeCompany } = useAuth();

  return activeCompany ? <Outlet /> : <Navigate to="auth/company" replace />;
};
